import { fetchEmptyParts, reindexEmptyParts } from '../../api/bookparts';

export default {
    idle() {
        this.fetchBook();
    },
    async setup() {
        this.preparing = true;

        try {
            await this.fetchSchema();
            this.transition({ type: 'DONE' });
        } catch (error) {
            this.transition({ type: 'FAILED', error });
        } finally {
            this.preparing = false;
        }
    },
    async checking() {
        if (!this.checkingParts) {
            return this.transition({ type: 'SKIP' });
        }

        this.preparing = true;
        try {
            const { length } = await fetchEmptyParts(this.bookId);
            this.dialogBrokenParts = !!length;
            if (!length) {
                this.transition({ type: 'FETCH' });
            }
        } catch (error) {
            this.transition({ type: 'FAILED', error });
        } finally {
            this.preparing = false;
        }
    },
    async repairing() {
        this.dialogBrokenParts = false;
        this.preparing = true;

        try {
            await reindexEmptyParts(this.bookId);
            this.transition({ type: 'DONE' });
        } catch (error) {
            this.transition({ type: 'FAILED', error });
        } finally {
            this.preparing = false;
        }
    },
    async fetching({ type }) {
        this.loading = true;
        this.preparing = false;
        this.preloadStatus = undefined;
        this.open();

        try {
            if (type === 'DONE') await this.refetchBook();
            const resources = await Promise.all(this.getBuilders().map(b => b.fetch()));
            this.transition({ type: 'DONE', resources });
        } catch (error) {
            this.transition({ type: 'FAILED', error });
        } finally {
            this.loading = false;
        }
    },
    ready({ resources = [] }) {
        this.bookBuilds = resources.flatMap(r => r);
    },
    async building({ params = {}, event = {} }) {
        this.loading = true;
        try {
            await this.builderFactory.building(params, event);
            this.transition({ type: 'QUEUED' }, event);
        } catch (error) {
            this.transition({ type: 'FAILED', error });
        }
    },
    queued() {
        this.loading = true;
        this.builderFactory.queueChecking();
    },
    async completed() {
        this.loading = false;
        this.transition({ type: 'DONE' });
        this.reset();
    },
    finished({ event = {} }) {
        this.log({ event });
        this.transition({ type: 'RESET' });
    },
    failed({ error }) {
        this.log({
            type: 'error',
            title: error
        });
        this.transition({ type: 'RESET' });
    },
    reset() {
        this.reset();
        this.transition({ type: 'READY' });
    }
};
